import { render, staticRenderFns } from "./devicesDashboardList.vue?vue&type=template&id=6195e448&scoped=true&xmlns=true"
import script from "./devicesDashboardList.vue?vue&type=script&lang=js"
export * from "./devicesDashboardList.vue?vue&type=script&lang=js"
import style0 from "./devicesDashboardList.vue?vue&type=style&index=0&id=6195e448&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6195e448",
  null
  
)

export default component.exports